import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import { useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import AnswerDropDown from "../component/AnswerDropDown";
import useForm from "../../../../hooks/useForm";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import URLS from "../../../../API/Axios/URLS";


function Selectables({
                         data,
                         showAnswer,
                         selectedOptions,
                         setSelectedOptions
                     }) {


    return (
        <div className={"grid grid-cols-3 md:grid-cols-8 gap-4"}>

            {
                data?.wordList?.map((option, index) => {
                    return (
                        <div
                            onClick={() => {
                                if (!showAnswer) {
                                    if (selectedOptions?.includes(option)) {
                                        setSelectedOptions( selectedOptions.filter((item) => item !== option))
                                    } else {
                                        setSelectedOptions([...selectedOptions, option])
                                    }
                                }


                            }}
                            className={`border border-gray-500 p-2 px-3 text-center
                            ${showAnswer && data?.correct?.includes(option) && selectedOptions?.includes(option) ? "bg-green-500 text-white border-green-200" : ""}
                            ${showAnswer && data?.correct?.includes(option) && !selectedOptions?.includes(option) ? "font-semibold text-green-500 border-2 border-green-600" : ""}
                            ${selectedOptions?.includes(option) ? "bg-blue-500 border-blue-200 text-white" : ""}
                            ${showAnswer && !data?.correct?.includes(option) && selectedOptions?.includes(option) ? "bg-red-500 text-white border-red-200" : ""}
                            `}>
                            <p>{option}</p>

                        </div>
                    )
                })}
        </div>
    )
}

export default function ReadAndSelect({className, ...props}) {
    const {id} = useParams()
    const [response, setResponse] = useState(null)
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: [],
    })

    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id]);


    function submitAnswer() {
        if (form?.answer.length === 0) {
            actions.setError({
                non_field_errors: ["Please select at least one option"]
            })
            return
        }
        actions.post(URLS.genericQuestionView, (data) => {
            return {
                ...data,
                answer: form?.answer.join(",")
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
        })


    }

        return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 5000}

            />
            {/*<GenericQuestionModal*/}
            {/*    result={response}*/}
            {/*    showModal={showModal} setShowModal={setShowModal}/>*/}
            <div className={" flex flex-col p-2 py-8 justify-between border-b-2"}>
                <Selectables
                    data={question}
                    showAnswer={!!response}
                    selectedOptions={form?.answer}
                    setSelectedOptions={(e) => {
                        setFormData({
                            answer: e
                        })
                    }}

                />
                <FormNoneFieldErrors className={"mt-3"} errors={error?.answer || error?.non_field_errors || error?.time}/>

            </div>
            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            onClickSubmit={submitAnswer}


            />

            <AnswerDropDown
                headerTitle={"Answer"}
                justifications={
                    question?.correct?.join(", ")
                }
            />


        </div>

    )
}
